var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22137 11.0453C9.35906 11.1085 9.51417 11.123 9.66117 11.0863C9.80816 11.0496 9.93826 10.9639 10.03 10.8433L10.2667 10.5333C10.3909 10.3677 10.5519 10.2333 10.7371 10.1407C10.9222 10.0482 11.1264 9.99998 11.3334 9.99998H13.3334C13.687 9.99998 14.0261 10.1405 14.2762 10.3905C14.5262 10.6406 14.6667 10.9797 14.6667 11.3333V13.3333C14.6667 13.6869 14.5262 14.0261 14.2762 14.2761C14.0261 14.5262 13.687 14.6666 13.3334 14.6666C10.1508 14.6666 7.09853 13.4024 4.84809 11.1519C2.59766 8.90149 1.33337 5.84924 1.33337 2.66665C1.33337 2.31302 1.47385 1.97389 1.7239 1.72384C1.97395 1.47379 2.31309 1.33331 2.66671 1.33331H4.66671C5.02033 1.33331 5.35947 1.47379 5.60952 1.72384C5.85956 1.97389 6.00004 2.31302 6.00004 2.66665V4.66665C6.00004 4.87364 5.95185 5.07779 5.85928 5.26293C5.76671 5.44807 5.6323 5.60912 5.46671 5.73331L5.15471 5.96731C5.03232 6.06076 4.94605 6.1937 4.91057 6.34355C4.87508 6.49339 4.89256 6.6509 4.96004 6.78931C5.87116 8.63989 7.36966 10.1365 9.22137 11.0453Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.e5c61b85336d53c0f3e0a4bbac61537c.svg";
export { ForwardRef as ReactComponent };